<button mat-button [disabled]="disabled">
  <div *ngIf="multiSeletect" class="check-circle">
    <mat-icon svgIcon="check-circle" *ngIf="selected; else uncheck"></mat-icon>
    <ng-template #uncheck>
      <div class="uncheck-circle"></div>
    </ng-template>
  </div>
  <span class="name">{{ staff.name }}</span>
  <div class="auto-margin"></div>
  <span class="job">{{ staff.jobnm }}</span>
</button>
